import React, { useState } from "react";
import Sidebar from "../sidebar";
import Navbar from "../Navbar";
import { Outlet } from "react-router-dom";

const MainLayout: React.FC = () => {
  // Added state to control the mobile slide-out menu drawer
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <div className="bg-gray-100 dark:bg-black min-h-screen flex flex-col">
      <div className="sticky top-0 z-50">
        <Navbar onMenuToggle={toggleMobileSidebar} />
      </div>

      <div className="flex flex-1 relative">
        {isMobileSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
            onClick={toggleMobileSidebar}
          />
        )}

        <div
          className={`
            fixed top-0 bottom-0 left-0 z-50 w-[285px] bg-white dark:bg-zinc-950 transform transition-transform duration-300 ease-in-out
            lg:relative lg:top-auto lg:bottom-auto lg:left-auto lg:z-0 lg:transform-none lg:w-auto
            ${isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
          `}
        >
          <Sidebar onClose={toggleMobileSidebar} />
        </div>

        {/* MAIN CONTENT AREA */}
        <div className="flex-1 w-full px-4 lg:px-8 pt-4 lg:pt-6 overflow-x-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
